import React from "react";
import "./ResourcesCard.scss"
const ResourcesCard = ({ icon, header, subheader, iconColor }) => {
    return (
        <div className="ResourcesCard">
            <div className={iconColor === "green" ? "ResourcesCard-icon-green" : "ResourcesCard-icon-blue"}>
                <img alt="" src={icon} />
            </div>
            <div className="ResourcesCard-header">
                {header}
            </div>
            <div className="ResourcesCard-subheader">
                {subheader}
            </div>
        </div>
    )
}
export default ResourcesCard